var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wallet-table",
    {
      staticClass: "vip-list-table",
      attrs: {
        headList: _vm.headList,
        contentList: _vm.contentList,
        clickCell: _vm.clickCell
      }
    },
    [
      _vm._v(">\n    "),
      _vm._l(_vm.contentList, function(item, i) {
        return _c(
          "div",
          { key: i, attrs: { slot: i + "addrBefore" }, slot: i + "addrBefore" },
          [
            _c("span", { staticClass: "beneficial-addr" }, [
              _vm._v(_vm._s(item.address))
            ]),
            _vm._v(" "),
            item.address === _vm.address
              ? _c("img", {
                  staticClass: "beneficial-img",
                  attrs: { src: require("assets/imgs/mine.svg") }
                })
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      _vm._l(_vm.contentList, function(item, i) {
        return _c("span", {
          key: i,
          staticClass: "icon",
          class: item.type,
          attrs: { slot: i + "typeiconAfter" },
          slot: i + "typeiconAfter"
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.contentList, function(item, i) {
        return _c(
          "span",
          {
            key: i,
            staticClass: "cancel",
            class: { active: item.isMaturity },
            attrs: { slot: i + "cancelBefore" },
            slot: i + "cancelBefore"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("tradeVip.cancel", { type: item.type }))
            )
          ]
        )
      }),
      _vm._v(" "),
      _c("pagination", {
        staticClass: "__tb_pagination",
        attrs: {
          slot: "tableBottom",
          totalPage: _vm.totalPage,
          currentPage: _vm.pageIndex + 1,
          toPage: _vm.getVipList
        },
        slot: "tableBottom"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }